var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_407",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28885",
    "data-name": "Group 28885",
    transform: "translate(-5057 6275)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5057, -6275)",
    filter: "url(#Ellipse_407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407-2",
    "data-name": "Ellipse 407",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_6_",
    "data-name": "svgexport-17 (6)",
    transform: "translate(5078 -6259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49779",
    "data-name": "Path 49779",
    d: "M32.725,24.522C24.819,38.216,12.8,17.4,28.61,17.4c-15.812,0-3.792-20.82,4.114-7.126-7.906-13.694,16.135-13.694,8.229,0C48.86-3.424,60.88,17.4,45.068,17.4c15.812,0,3.792,20.82-4.114,7.126C48.86,38.216,24.819,38.216,32.725,24.522Z",
    transform: "translate(-20.864 0.001)",
    fill: "#ff728b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49780",
    "data-name": "Path 49780",
    d: "M45.319,17.387,37.3,17.279l0-.007H37.3l3.907-7c7.906-13.694-16.135-13.694-8.229,0l3.907,7h-.008l0,.007-8.018.144C13.05,17.477,25.139,38.257,33,24.537l4.088-6.9,0,.006,0-.007,4.119,6.88c7.923,13.684,19.918-7.151,4.106-7.131Z",
    transform: "translate(-21.115 0)",
    fill: "#ff3f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49781",
    "data-name": "Path 49781",
    d: "M97.737,166.968a.533.533,0,0,0-.533.533v2.237a.533.533,0,1,0,1.065,0V167.5a.533.533,0,0,0-.532-.533Zm-8.455-17.129,1.371,1.138a.533.533,0,0,0,.68-.82l-1.371-1.138a.533.533,0,1,0-.68.82Zm-.832,10.766-1.969,1.066a.533.533,0,1,0,.507.937l1.969-1.066a.533.533,0,1,0-.507-.937ZM107.325,164l-1.419-1.265a.533.533,0,0,0-.709.795l1.419,1.265a.533.533,0,1,0,.709-.795Z",
    transform: "translate(-81.761 -138.779)",
    fill: "#ff0c38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49782",
    "data-name": "Path 49782",
    d: "M120.134,64.3l-8.187-2.9,8.294-5.237a.533.533,0,1,0-.569-.9l-8.4,5.307V52.626a.533.533,0,1,0-1.065,0V60.4l-4.5-3.736a.533.533,0,1,0-.68.82l3.049,2.53-7.223-2.587a.533.533,0,1,0-.359,1l8.946,3.2-5.708,3.091a.533.533,0,1,0,.507.937l5.955-3.225,0,8.187a.533.533,0,0,0,.533.532h0a.533.533,0,0,0,.532-.533l0-7.914,5.562,4.959a.533.533,0,1,0,.709-.8l-4.41-3.932,6.665,2.361a.533.533,0,0,0,.356-1Zm-9.4-13.628a.533.533,0,0,0,.533-.533V47.892a.533.533,0,1,0-1.065,0v2.249a.533.533,0,0,0,.533.533Z",
    transform: "translate(-94.747 -44.141)",
    fill: "#ff0c38"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 4.154,
    cy: 4.154,
    rx: 4.154,
    ry: 4.154,
    transform: "translate(11.834 13.243)",
    fill: "#ffeb99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49783",
    "data-name": "Path 49783",
    d: "M197.111,199.027a4.155,4.155,0,0,1,3.1-4.019,4.154,4.154,0,1,0,0,8.038A4.156,4.156,0,0,1,197.111,199.027Z",
    transform: "translate(-183.171 -181.63)",
    fill: "#ffda44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.4b53080f818b186e185ea2f4b0fb3f8a.svg";
export { ForwardRef as ReactComponent };